module.exports = __webpack_public_path__ + "static/img/phone3.e5cbaf46.png";